import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export class MediaQuery {
    private queryList: MediaQueryList;
    private subj: BehaviorSubject<boolean>;

    constructor(query: string) {
        this.queryList = window.matchMedia(query);
        this.subj = new BehaviorSubject(this.queryList.matches);
        this.queryList.addEventListener('change', this.onChange);
    }

    get value() {
        return this.subj.value;
    }

    get obs() {
        return this.subj.asObservable();
    }

    destroy() {
        this.queryList.removeEventListener('change', this.onChange);
    }

    private onChange = (ev: MediaQueryListEvent) => {
        this.subj.next(ev.matches);
    };
}

@Injectable({ providedIn: 'root' })
export class MediaQueryManager {
    private queries = new Map<string, MediaQuery>();

    getQuery(query: string) {
        const existing = this.queries.get(query) ?? new MediaQuery(query);
        this.queries.set(query, existing);
        return existing;
    }

    destroyQuery(query: string) {
        this.queries.get(query)?.destroy();
        this.queries.delete(query);
    }
}
